import { useIsAskMeAnythingLoadedInTeamsQnaApp } from './selectors';
import { useIsStrictlyTeamsQna } from './useIsStrictlyTeamsQna';

export const useIsTeamsQnaUxUpdatesEnabled = (): boolean => {
  const isAskMeAnythingLoadedInTeamsQna = useIsAskMeAnythingLoadedInTeamsQnaApp();
  const isStrictlyTeamsQna = useIsStrictlyTeamsQna();

  return isAskMeAnythingLoadedInTeamsQna || isStrictlyTeamsQna;
};
